import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';
import Cookies from 'cookies-js';

export const initialAuthState = {
  checkTokenStatus: STATUS.IDLE,
  loginStatus: STATUS.IDLE,
  status: STATUS.IDLE,
  passwordResetStatus: STATUS.IDLE,
  passwordConfirmationStatus: STATUS.IDLE,
  error: null,
  is2faEnabled: false,
  confirmationToken: null,
  impersonated: false,
};

export default (state = initialAuthState, action) => {
  const { payload } = action;
  switch (action?.type) {
    case types.LOGIN:
      return {
        ...state,
        loginStatus: STATUS.LOADING,
      };
    case resolve(types.LOGIN):
      return {
        ...state,
        token: !payload?.has_2fa_enabled ? payload?.access : '',
        refreshToken: !payload?.has_2fa_enabled ? payload?.refresh : '',
        is2faEnabled: !!payload?.has_2fa_enabled,
        loginStatus: STATUS.LOADED,
        confirmationToken: payload?.token,
        redirectTo: payload?.redirect_to,
        impersonated: false,
        loginError: null,
      };
    case reject(types.LOGIN):
      const jsonError = JSON.parse(action?.error?.responseData || '{}');
      return {
        ...state,
        loginError: true,
        loginStatus: STATUS.ERROR,
        redirectTo: jsonError?.redirect_to,
        env: jsonError.env,
      };
    case types.IMPERSONATE:
      return {
        ...state,
        impersonateStatus: STATUS.LOADING,
      };
    case resolve(types.IMPERSONATE):
      if (caches) {
        caches.keys().then(function (names) {
          for (let name of names) {
            console.log(`deleting cached ${name}`);
            caches.delete(name);
          }
        });
      }
      Cookies.set('impersonated', true);
      return {
        ...state,
        token: payload?.access,
        refreshToken: payload?.refresh,
        loginStatus: STATUS.LOADED,
        confirmationToken: payload?.token,
        impersonated: true,
        error: null,
      };
    case reject(types.IMPERSONATE):
      return {
        ...state,
        error: true,
        impersonateStatus: STATUS.ERROR,
      };

    case resolve(types.LOGIN_WITH_2FA):
      return {
        ...state,
        token: action?.payload?.access,
        refreshToken: action?.payload?.refresh,
        loginStatus: STATUS.LOADED,
        loginError: null,
      };
    case reject(types.LOGIN_WITH_2FA):
      return {
        ...state,
        loginError: true,
        loginStatus: STATUS.ERROR,
      };
    case types.CHECK_TOKEN:
      return {
        ...state,
        checkTokenStatus: STATUS.LOADING,
      };
    case resolve(types.CHECK_TOKEN):
      return {
        ...state,
        uid: payload?.uid,
        token: payload?.token,
        checkTokenStatus: STATUS.LOADED,
        error: null,
      };
    case reject(types.CHECK_TOKEN):
      try {
        const jsonError = JSON.parse(action?.error?.responseData || '{}');
        return {
          ...state,
          error: true,
          errorMessages: jsonError['uid'][0],
          checkTokenStatus: STATUS.ERROR,
        };
      } catch (e) {
        return {
          ...state,
          error: true,
          errorMessages:
            'Your invitation to join Silent Push has expired. Please contact an admin of your Organisation in Silent Push App and ask him to reset your account.',
          checkTokenStatus: STATUS.ERROR,
        };
      }
    case types.REFRESH_TOKEN:
      return {
        ...state,
        loginStatus: STATUS.LOADING,
        tokenStatus: STATUS.LOADING,
      };
    case resolve(types.REFRESH_TOKEN):
      return {
        ...state,
        token: !payload?.has_2fa_enabled ? payload?.access : '',
        //refreshToken: !payload.has_2fa_enabled ? payload.refresh : '',
        is2faEnabled: !!payload?.has_2fa_enabled,
        loginStatus: STATUS.LOADED,
        tokenStatus: STATUS.LOADED,
        confirmationToken: payload?.token,
        error: null,
      };
    case reject(types.REFRESH_TOKEN):
      return {
        ...state,
        error: true,
        loginStatus: STATUS.ERROR,
        tokenStatus: STATUS.ERROR,
      };
    case types.LOGOUT:
      Cookies.expire('impersonated');
      return {
        ...state,
        loginStatus: STATUS.IDLE,
        token: '',
        impersonated: false,
      };

    case types.REGISTER:
      return {
        ...state,
        registerStatus: STATUS.RUNNING,
      };
    case resolve(types.REGISTER):
      return {
        ...state,
        registerStatus: STATUS.SUCCESS,
      };
    case reject(types.REGISTER):
      return {
        ...state,
        registerStatus: STATUS.ERROR,
      };

    case types.RESET_PASSWORD:
      return {
        ...state,
        passwordResetStatus: STATUS.RUNNING,
      };
    case resolve(types.RESET_PASSWORD):
      return {
        ...state,
        passwordResetStatus: STATUS.SUCCESS,
      };
    case reject(types.RESET_PASSWORD):
      return {
        ...state,
        passwordResetStatus: STATUS.ERROR,
      };

    case types.VALIDATE_EMAIL_ON_REGISTER:
      return {
        ...state,
        emailConfirmationStatus: STATUS.RUNNING,
        errorMessages: null,
      };
    case resolve(types.VALIDATE_EMAIL_ON_REGISTER):
      return {
        ...state,
        emailConfirmationStatus: STATUS.SUCCESS,
      };
    case reject(types.VALIDATE_EMAIL_ON_REGISTER):
      return {
        ...state,
        emailConfirmationStatus: STATUS.ERROR,
        errorMessages: action?.errorMessages,
      };

    case types.CONFIRM_PASSWORD_RESET:
      return {
        ...state,
        passwordConfirmationStatus: STATUS.RUNNING,
      };
    case resolve(types.CONFIRM_PASSWORD_RESET):
      return {
        ...state,
        passwordConfirmationStatus: STATUS.SUCCESS,
      };
    case reject(types.CONFIRM_PASSWORD_RESET):
      return {
        ...state,
        passwordConfirmationStatus: STATUS.ERROR,
        errorMessages: action?.errorMessages,
      };
    case types.LOAD_2FA_QR:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_2FA_QR):
      return {
        ...state,
        qrCode: action?.payload,
        status: STATUS.LOADED,
      };
    case types.ENABLE_2FA:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.ENABLE_2FA):
      return {
        ...state,
        status: STATUS.LOADED,
        is2faEnabled: true,
      };
    case reject(types.ENABLE_2FA):
      return {
        ...state,
        status: STATUS.ERROR,
      };
    case resolve(types.REMOVE_2FA):
      return {
        ...state,
        is2faEnabled: false,
      };
    case resolve(types.LOAD_USER):
      return {
        ...state,
        is2faEnabled: !!action?.payload?.user?.has_2fa_enabled,
      };
    default:
      return state;
  }
};
